(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderQuoteRequestsController', AppraisalOrderQuoteRequestsController);

    AppraisalOrderQuoteRequestsController.$inject = ['$mdDialog', '$http', 'order', 'AppraisalOrder', 'AppraiserUser', 'suggestedAppraisers', 'eligibleAppraisers', 'independentAppraisers', 'partialCoverageAppraisers', 'regionalCoverageAppraisers', 'Principal', 'AlertService'];

    function AppraisalOrderQuoteRequestsController($mdDialog, $http, order, AppraisalOrder, AppraiserUser, suggestedAppraisers, eligibleAppraisers, independentAppraisers, partialCoverageAppraisers, regionalCoverageAppraisers, Principal, AlertService) {
        var vm = this;

        vm.order = order;
        vm.suggestedAppraisers = suggestedAppraisers || [];
        vm.eligibleAppraisers = eligibleAppraisers || [];
        vm.independentAppraisers = independentAppraisers || [];
        vm.selectedSuggestedAppraisers = [];
        vm.selectedEligibleAppraisers = [];
        vm.selectedIndependentAppraisers = [];
        // Ticked in the assign dialog's Partial Lender Coverage table; can be removed here but not added
        vm.selectedPartialCoverageAppraisers = (partialCoverageAppraisers || []).slice();
        // Ticked in the assign dialog's Regional Coverage table; same rules as above
        vm.selectedRegionalCoverageAppraisers = (regionalCoverageAppraisers || []).slice();
        vm.manualEmailChips = [];
        vm.manualEmailSearchText = '';
        vm.orderDetails = '';
        vm.emailLanguage = 'en';
        vm.replyToEmail = 'info@valueconnect.ca';
        vm.ccEmail = 'info@valueconnect.ca';
        vm.isSaving = false;
        vm.selectedExistingFiles = {};
        vm.newFiles = [];
        vm.fileApi = null;
        vm.includeStandardQuote = false;
        vm.includeRushQuote = false;
        vm.isVCEmployee = Principal.hasAnyAuthority([/^ROLE_(ADMIN|VC|CUSTOMER_CARE).*/]);

        vm._baseDetails = '';
        vm._detailsWithAppend = '';

        loadOrderDetails('en');


        vm.cancel = cancel;
        vm.send = send;
        vm.matchAppraisers = matchAppraisers;
        vm.getSuggestedAppraiserText = getSuggestedAppraiserText;
        vm.getAppraiserText = getAppraiserText;
        vm.transformChip = transformChip;
        vm.hasExistingFiles = hasExistingFiles;
        vm.copyChipEmail = copyChipEmail;
        vm.addManualEmail = addManualEmail;
        vm.addSuggestedAppraiser = addSuggestedAppraiser;
        vm.addEligibleAppraiser = addEligibleAppraiser;
        vm.addIndependentAppraiser = addIndependentAppraiser;
        vm.filterSelectedAppraisers = filterSelectedAppraisers;
        vm.onEmailLanguageChange = onEmailLanguageChange;
        vm.onAppendCheckboxChange = onAppendCheckboxChange;

        function loadOrderDetails(lang) {
            lang = lang || vm.emailLanguage;
            var params = { id: vm.order.id, lang: lang };
            AppraisalOrder.getQuoteRequestDetails(params, function(response) {
                vm._baseDetails = response.details;
                vm._detailsWithAppend = response.detailsWithAppend;
                var useAppend = vm.order.rush ? vm.includeStandardQuote : vm.includeRushQuote;
                vm.orderDetails = useAppend ? vm._detailsWithAppend : vm._baseDetails;
            }, function(error) {
                AlertService.error('Failed to load order details');
            });
        }

        function onEmailLanguageChange() {
            loadOrderDetails(vm.emailLanguage);
        }

        function onAppendCheckboxChange() {
            var useAppend = vm.order.rush ? vm.includeStandardQuote : vm.includeRushQuote;
            vm.orderDetails = useAppend ? vm._detailsWithAppend : vm._baseDetails;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip;
            }
            return null;
        }

        function hasExistingFiles() {
            return (vm.order.customForms && vm.order.customForms.length > 0) ||
                   (vm.order.supportingDocumentation && vm.order.supportingDocumentation.length > 0) ||
                   (vm.order.agreementPurchase && vm.order.agreementPurchase.length > 0) ||
                   (vm.order.mlsPropertySheet && vm.order.mlsPropertySheet.length > 0);
        }

        function copyChipEmail($chip, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            if ($chip && $chip.userEmail) {
                navigator.clipboard.writeText($chip.userEmail).then(function() {
                    AlertService.success('valueconnectApp.appraisalOrder.quoteRequests.emailCopied');
                }).catch(function() {
                    AlertService.error('valueconnectApp.appraisalOrder.quoteRequests.emailCopyFailed');
                });
            }
        }

        function addManualEmail() {
            vm.manualEmailError = null;
            if (vm.manualEmailSearchText && vm.manualEmailSearchText.trim().length > 0) {
                var email = vm.manualEmailSearchText.trim();
                if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    vm.manualEmailError = 'Invalid email address: ' + email;
                    return;
                }
                vm.manualEmailChips.push(email);
                vm.manualEmailSearchText = '';
            }
        }

        function getSelectedExistingFileIds() {
            var fileIds = [];
            for (var fileId in vm.selectedExistingFiles) {
                if (vm.selectedExistingFiles[fileId]) {
                    fileIds.push(parseInt(fileId, 10));
                }
            }
            return fileIds;
        }

        function send() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            var emailArray = [];
            vm.manualEmailError = null;

            // Check if there's uncommitted text in the manual email input
            if (vm.manualEmailSearchText && vm.manualEmailSearchText.trim().length > 0) {
                vm.manualEmailError = 'Please press the Add Email button to finalize the email address';
                vm.isSaving = false;
                return;
            }
            
            if (vm.manualEmailChips && vm.manualEmailChips.length > 0) {
                for (var i = 0; i < vm.manualEmailChips.length; i++) {
                    var email = vm.manualEmailChips[i].trim();
                    if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                        vm.manualEmailError = 'Invalid email address: ' + email;
                        vm.isSaving = false;
                        return;
                    }
                    emailArray.push(email);
                }
            }

            if (!vm.replyToEmail || !vm.replyToEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                AlertService.error('Please enter a valid Reply-To email address');
                vm.isSaving = false;
                return;
            }

            var totalRecipients = emailArray.length + 
                                (vm.selectedSuggestedAppraisers ? vm.selectedSuggestedAppraisers.length : 0) +
                                (vm.selectedEligibleAppraisers ? vm.selectedEligibleAppraisers.length : 0) +
                                (vm.selectedIndependentAppraisers ? vm.selectedIndependentAppraisers.length : 0) +
                                vm.selectedPartialCoverageAppraisers.length +
                                vm.selectedRegionalCoverageAppraisers.length;
            
            if (totalRecipients === 0) {
                AlertService.error('Please select at least one recipient (appraiser or manual email address)');
                vm.isSaving = false;
                return;
            }

            var quoteRequestDTO = {
                appraisalOrderId: vm.order.id,
                emailAddresses: emailArray,
                // The backend looks up any appraiser id here, so coverage table recipients go with the suggested ones
                suggestedAppraiserIds: vm.selectedSuggestedAppraisers.concat(vm.selectedPartialCoverageAppraisers, vm.selectedRegionalCoverageAppraisers).map(function(a) { return a.id; }),
                eligibleAppraiserIds: vm.selectedEligibleAppraisers.map(function(a) { return a.id; }),
                independentAppraiserIds: vm.selectedIndependentAppraisers.map(function(a) { return a.id; }),
                orderDetails: vm.orderDetails,
                replyToEmail: vm.replyToEmail,
                ccEmail: vm.ccEmail,
                language: vm.emailLanguage,
                includeStandardQuote: vm.includeStandardQuote,
                includeRushQuote: vm.includeRushQuote,
                existingFileIds: getSelectedExistingFileIds()
            };

            var formData = new FormData();
            formData.append('quoteRequest', new Blob([JSON.stringify(quoteRequestDTO)], { type: 'application/json' }));
            
            if (vm.newFiles && vm.newFiles.length > 0) {
                for (var j = 0; j < vm.newFiles.length; j++) {
                    if (vm.newFiles[j].lfFile) {
                        formData.append('files', vm.newFiles[j].lfFile);
                    }
                }
            }

            $http.post('api/appraisal-orders/send-quote-requests', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(
                function success() {
                    vm.isSaving = false;
                    AlertService.success('valueconnectApp.appraisalOrder.quoteRequests.success');
                    $mdDialog.hide();
                },
                function error(response) {
                    vm.isSaving = false;
                    AlertService.error((response.data && response.data.message) || 'Error sending quote requests');
                }
            );
        }

        function matchAppraisers(searchText, appraisers) {
            if (!searchText) {
                return appraisers;
            }
            var searchRegex = new RegExp(searchText, 'gi');
            return appraisers.filter(function(appraiser) {
                var text = getAppraiserText(appraiser);
                return searchRegex.test(text);
            });
        }

        function getSuggestedAppraiserText(item) {
            var textStrArray = [];
            textStrArray.push(item.userFullName);

            if (item.userEmail) {
                textStrArray.push('- ' + item.userEmail);
            }

            if (item.appraisalFirmAssistantName) {
                textStrArray.push('(' + item.appraisalFirmAssistantName + ')');
            }
            textStrArray.push('|');
            textStrArray.push(item.appraisalFirmName);

            if (item.isFirmRostered) {
                textStrArray.push('| Rostered');
            }

            if (item.isFirmIndependent) {
                textStrArray.push('| Independent');
            }

            return textStrArray.join(' ');
        }

        function getAppraiserText(item) {
            var text = item.userFullName;
            if (item.userEmail) {
                text += ' - ' + item.userEmail;
            }
            text += ' | ' + item.appraisalFirmName;
            return text;
        }

        function addSuggestedAppraiser(item) {
            if (item && !isAppraiserInList(item, vm.selectedSuggestedAppraisers)) {
                vm.selectedSuggestedAppraisers.push(item);
            }
            vm.selectedAppraiser = null;
        }

        function addEligibleAppraiser(item) {
            if (item && !isAppraiserInList(item, vm.selectedEligibleAppraisers)) {
                vm.selectedEligibleAppraisers.push(item);
            }
            vm.selectedAppraiserOther = null;
        }

        function addIndependentAppraiser(item) {
            if (item && !isAppraiserInList(item, vm.selectedIndependentAppraisers)) {
                vm.selectedIndependentAppraisers.push(item);
            }
            vm.selectedAppraiserIndependent = null;
        }

        function filterSelectedAppraisers(appraisers, selectedList) {
            if (!appraisers) return [];

            return appraisers.filter(function(appraiser) {
                return !isAppraiserInList(appraiser, selectedList)
                    && !isAppraiserInList(appraiser, vm.selectedPartialCoverageAppraisers)
                    && !isAppraiserInList(appraiser, vm.selectedRegionalCoverageAppraisers);
            });
        }

        function isAppraiserInList(appraiser, list) {
            if (!list) return false;
            return list.some(function(item) {
                return item.id === appraiser.id;
            });
        }
    }
})();

